/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// ===== Global interceptor to ensure meal properties are included in cart submission =====
(function() {
  'use strict';
  
  // Function to ensure all meal properties are set correctly
  function ensureMealProperties() {
    try {
      var form = document.querySelector('form.ProductForm');
      if (!form) return;
      
      var mealInputs = form.querySelectorAll('.val-input');
      if (!mealInputs || mealInputs.length === 0) return;
      
      for (var i = 0; i < mealInputs.length; i++) {
        var input = mealInputs[i];
        if (input && input.value) {
          var parent = input.closest('.mealweekm_main');
          if (parent) {
            var mealName = parent.dataset.mealname || 'Meal';
            if (!input.name || input.name.indexOf('properties[') === -1) {
              input.name = 'properties[' + mealName + ']';
            }
          }
        }
      }
    } catch(e) {
      console.error('Error ensuring meal properties:', e);
    }
  }
  
  // Intercept add-to-cart button clicks VERY early (capture phase)
  // This runs BEFORE form serialization happens
  document.addEventListener('click', function(e) {
    try {
      var addToCartBtn = e.target.closest('[data-action="add-to-cart"]');
      if (addToCartBtn) {
        // Set properties immediately when button is clicked
        // This ensures they're available when form serialization happens
        ensureMealProperties();
        
        // Also set a small delay to catch any async operations
        setTimeout(function() {
          ensureMealProperties();
        }, 0);
      }
    } catch(err) {
      console.error('Error in click handler:', err);
    }
  }, true); // Capture phase - runs first
  
  // Also watch for form submit events
  document.addEventListener('submit', function(e) {
    try {
      var form = e.target;
      if (form && form.classList.contains('ProductForm')) {
        ensureMealProperties();
      }
    } catch(err) {
      console.error('Error in submit handler:', err);
    }
  }, true); // Capture phase
  
  // Store original fetch function only if it exists
  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch;
    
    // Override fetch to intercept cart add requests
    window.fetch = function(url, options) {
      try {
        var isCartAdd = false;
        var urlString = '';
        
        // Check if this is a cart add request
        if (typeof url === 'string') {
          urlString = url;
          if (url.indexOf('/cart/add') !== -1) {
            isCartAdd = true;
          }
        } else if (url && typeof url === 'object' && url.url) {
          urlString = url.url;
          if (url.url.indexOf('/cart/add') !== -1) {
            isCartAdd = true;
          }
        } else if (url && typeof url === 'object' && url.toString) {
          urlString = url.toString();
          if (urlString.indexOf('/cart/add') !== -1) {
            isCartAdd = true;
          }
        }
        
        if (isCartAdd) {
          // Ensure properties are set BEFORE we process the payload
          // This is critical for one-time purchases where form serialization might miss them
          ensureMealProperties();
          
          var form = document.querySelector('form.ProductForm');
          if (form && options && options.body && typeof options.body === 'string') {
            try {
              var payload = JSON.parse(options.body);
              
              // Check if this is a one-time purchase (no selling_plan) or subscription
              var isOneTime = !payload.selling_plan || payload.selling_plan === '';
              
              // Build properties array from form inputs
              // Shopify's cart API accepts both formats:
              // 1. Array format: properties: [{name: "Monday", value: "Meal"}]
              // 2. Object format: properties: {Monday: "Meal"} (gets converted by form serialization)
              // We'll use array format to be explicit
              var propertiesArray = [];
              var mealInputs = form.querySelectorAll('.val-input');
              
              // First, collect all properties from hidden inputs
              for (var i = 0; i < mealInputs.length; i++) {
                var input = mealInputs[i];
                if (input && input.value && input.name) {
                  var propName = '';
                  var propValue = input.value.trim();
                  
                  // Check if name is in properties[...] format
                  if (input.name.indexOf('properties[') !== -1) {
                    var match = input.name.match(/properties\[(.+?)\]/);
                    if (match && match[1]) {
                      propName = match[1];
                    }
                  } else if (input.name.indexOf('properties.') !== -1) {
                    // Handle properties.Monday format (from form serialization)
                    propName = input.name.replace('properties.', '');
                  }
                  
                  if (propName && propValue) {
                    propertiesArray.push({
                      name: propName,
                      value: propValue
                    });
                  }
                }
              }
              
              // Also check if payload already has properties in object format
              if (payload.properties && typeof payload.properties === 'object' && !Array.isArray(payload.properties)) {
                // Convert object format to array format
                for (var key in payload.properties) {
                  if (payload.properties.hasOwnProperty(key) && payload.properties[key]) {
                    var found = false;
                    for (var p = 0; p < propertiesArray.length; p++) {
                      if (propertiesArray[p].name === key) {
                        found = true;
                        break;
                      }
                    }
                    if (!found) {
                      propertiesArray.push({
                        name: key,
                        value: String(payload.properties[key])
                      });
                    }
                  }
                }
              }
              
              // Add properties to payload in Shopify's array format
              if (propertiesArray.length > 0) {
                // If payload already has properties as array, merge them
                if (payload.properties && Array.isArray(payload.properties)) {
                  // Merge arrays, avoiding duplicates
                  var existingProps = payload.properties;
                  for (var j = 0; j < propertiesArray.length; j++) {
                    var newProp = propertiesArray[j];
                    var exists = false;
                    for (var k = 0; k < existingProps.length; k++) {
                      if (existingProps[k].name === newProp.name) {
                        existingProps[k].value = newProp.value;
                        exists = true;
                        break;
                      }
                    }
                    if (!exists) {
                      existingProps.push(newProp);
                    }
                  }
                  payload.properties = existingProps;
                } else {
                  payload.properties = propertiesArray;
                }
                
                // Update the body with properties
                options.body = JSON.stringify(payload);
                
                // Debug log (remove in production if needed)
                console.log('Cart properties added:', propertiesArray);
                console.log('Purchase type:', isOneTime ? 'One-time' : 'Subscription');
                console.log('Final payload:', payload);
              } else {
                // Debug: log if no properties found
                console.warn('No meal properties found in form inputs');
                console.log('Form inputs:', mealInputs.length);
                console.log('Payload:', payload);
              }
            } catch(e) {
              console.error('Error parsing/updating cart payload:', e);
            }
          }
        }
      } catch(err) {
        console.error('Error in fetch interceptor:', err);
      }
      
      // Call original fetch
      return originalFetch.apply(this, arguments);
    };
  }
})();